'use strict';

var got = require('got');

module.exports = function (username) {
  return got("https://instagram.com/".concat(username)).then(function (res) {
    var data = res.body.split('"id":"')[1].split('",')[0];
    return data;
  }).catch(function (err) {
    if (err) {
      return err.message;
    }
  });
};